import React from "react";
import warehouseImg from "../assets/warehouse.png"; // Replace with your actual image path
import { motion } from "framer-motion";
import inventoryIcon from "../assets/inventory.png";
import barcodeIcon from "../assets/barcode.png";
import orderIcon from "../assets/order.png";
import spaceIcon from "../assets/space.png";
import multiIcon from "../assets/multi.png";
import reportIcon from "../assets/report.png";
import AOS from "aos";
import "aos/dist/aos.css";
import mapImage from "../assets/map-image.png"; 
import iconMap from "../assets/icon-map.svg"; 

import uptimeIcon from "../assets/icon-uptime.svg"; // upload your icon here
import brainImage from "../assets/brain-section.png";
const WarehouseHero = () => {
   
const features = [
  {
    icon: inventoryIcon,
    title: "Real-Time Inventory Tracking",
    description: "Know exactly where every item is — reduce errors and out-of-stock risks.",
  },
  {
    icon: barcodeIcon,
    title: "Barcode & RFID Integration",
    description: "Fast, accurate scanning for seamless receiving, picking, and shipping.",
  },
  {
    icon: orderIcon,
    title: "Order & Shipment Management",
    description: "Speed up order fulfillment with automated workflows and smart routing.",
  },
  {
    icon: spaceIcon,
    title: "Warehouse Space Optimization",
    description: "Maximize layout efficiency with AI-powered space and bin management.",
  },
  {
    icon: multiIcon,
    title: "Multi-Warehouse Support",
    description: "Centralized control over all your warehouse locations from one dashboard.",
  },
  {
    icon: reportIcon,
    title: "Reports & Analytics",
    description: "Track KPIs, stock levels, and operational efficiency with visual dashboards.",
  },
];
const stats = [
  {
    title: "85% Faster Order Processing",
    description:
      "Accelerate fulfillment speeds and reduce delays with intelligent, automated workflows.",
    bg: "bg-[#EEF4FF]",
    image: mapImage,
  },
  {
    title: "99.9% Inventory Accuracy",
    description:
      "Maintain precise stock levels and eliminate costly inventory errors with real-time tracking.",
    bg: "bg-[#FDFDFD]",
    image: mapImage,
  },
  {
    title: "40% Reduction in Stockouts",
    description:
      "Ensure product availability and boost customer satisfaction with smarter inventory planning.",
    bg: "bg-[#FDFDFD]",
    image: mapImage,
  },
];

    

  return (
    <>
    <section className="w-full bg-[#F8F8F8] py-20 px-4 sm:px-6">
  <div className="w-full max-w-[1312px] mx-auto flex flex-col lg:flex-row items-center justify-between gap-10">
    
{/* LEFT CONTENT */}
    <motion.div
      className="w-full lg:w-[60%]"
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      viewport={{ once: true }}
    >
      <p className="text-[#212129] font-semibold text-sm mb-3 uppercase tracking-wider">
        Warehouse management
      </p>
      <h1 className="text-[#212129] text-[40px] md:text-[48px] leading-[52px] md:leading-[58px] font-extrabold mb-[24px]">
         Smarter Warehousing<br className="hidden lg:block" />
        Starts Here
      </h1>
      <p className="text-[#212129] text-[16px] md:text-[18px] leading-[28px] md:leading-[30px] max-w-[600px]">
        Streamline your inventory, optimize space, and track every movement — all in real time with our powerful Warehouse Management System.
      </p>
    </motion.div>

    {/* RIGHT IMAGE */}
    <motion.div
      className="w-full lg:w-[40%] flex justify-center lg:justify-end"
      initial={{ opacity: 0, scale: 0.9 }}
      whileInView={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.6, ease: "easeOut", delay: 0.2 }}
      viewport={{ once: true }}
    >
      <img
            src={warehouseImg}
            alt="Warehouse  Illustration"
            className="w-[280px] sm:w-[360px] md:w-[420px] lg:w-full max-w-[500px] h-auto object-contain"
          />
    </motion.div>

  </div>
</section>
<section className="w-full bg-white py-20 px-4 md:px-8 lg:px-16 font-poppins">
      <motion.div
        className="max-w-[1280px] mx-auto text-center"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, ease: "easeOut" }}
      >
        <div className="inline-block bg-[#F1F1F1] text-xs font-semibold tracking-wider text-gray-600 px-4 py-1 rounded-full mb-4">
          WHAT WE DO
        </div>
        <h2 className="text-[32px] md:text-[42px] font-extrabold text-[#1E1E1E] mb-4">
          End-to-End Warehouse Control, <br className="hidden md:block" /> Simplified
        </h2>
        <p className="text-[#4B5563] text-base md:text-lg leading-relaxed max-w-3xl mx-auto">
          Our cloud-based WMS empowers businesses to automate storage, improve accuracy,
          and gain full visibility of warehouse operations — from inbound to outbound.
        </p>
      </motion.div>

      <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-[1280px] mx-auto">
        {features.map((item, index) => (
          <motion.div
            key={index}
            className="bg-[#F9FAFB] rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow duration-300"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
          >
            <img src={item.icon} alt={item.title} className="w-12 h-12 mb-4" />
            <h3 className="text-lg font-semibold text-[#1E1E1E] mb-2">{item.title}</h3>
            <span className="text-sm text-[#4B5563] wight-[]leading-relaxed">{item.description}</span>
          </motion.div>
        ))}
      </div>
    </section>
<section className="bg-[#f3f6fb] py-20 overflow-hidden">
  <div className="max-w-7xl mx-auto px-6 md:px-10 flex flex-col-reverse lg:flex-row items-center justify-between gap-16">
    
    {/* Left Column */}
    <div className="w-full lg:w-1/2">
      <div className="mb-4">
        <span className="inline-block bg-blue-100 text-blue-800 text-sm font-semibold px-4 py-1 rounded-full uppercase tracking-wider">
          Our Advantages
        </span>
      </div>
      <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-6">
        Why Choose Us
      </h2>
      <p className="text-lg text-gray-700 mb-10 max-w-xl">
        Empowering warehouses with speed, accuracy, and scalability you can trust.
      </p>

      {/* Timeline */}
      <div className="relative pl-10">
        {/* Vertical Line */}
        <div className="absolute left-4 top-7 bottom-0 w-0.5 bg-blue-300 z-0"></div>

        {/* Item 1 */}
        <div className="relative flex items-start mb-12">
          <div className="absolute left-4 top-1.5 w-3 h-3 bg-blue-500 rounded-full z-10"></div>
          <div className="ml-6">
            <div className="w-14 h-14 flex items-center justify-center rounded-full bg-white border border-gray-200 shadow-md mb-2">
              <img src={uptimeIcon} alt="Uptime Icon" className="w-6 h-6" />
            </div>
            <h4 className="text-blue-600 font-bold text-base mb-1">
              99.99% system uptime
            </h4>
            <p className="text-gray-600 text-sm max-w-sm">
              Maximize layout efficiency with AI-powered space and bin management.
            </p>
          </div>
        </div>

        {/* Item 2 */}
        <div className="relative flex items-start mb-12">
          <span className="absolute left-4 top-1.5 w-3 h-3 bg-blue-500 rounded-full z-10"></span>
          <div className="ml-10">
            <p className="text-gray-900 font-bold text-base">
              Used by 500+ warehouses globally
            </p>
          </div>
        </div>

        {/* Item 3 */}
        <div className="relative flex items-start mb-12">
          <span className="absolute left-4 top-1.5 w-3 h-3 bg-blue-500 rounded-full z-10"></span>
          <div className="ml-10">
            <p className="text-gray-900 font-bold text-base">
              100% customizable workflows
            </p>
          </div>
        </div>

        {/* Item 4 */}
        <div className="relative flex items-start">
          <span className="absolute left-4 top-1.5 w-3 h-3 bg-blue-500 rounded-full z-10"></span>
          <div className="ml-10">
            <p className="text-gray-900 font-bold text-base">
              24/7 expert support
            </p>
          </div>
        </div>
      </div>
    </div>

    {/* Right Column - Brain Image */}
    <div className="w-full lg:w-1/2 flex justify-center relative">
      <div className="relative w-[300px] md:w-[400px] lg:w-[460px]">
        <div className="absolute -top-10 -left-10 w-[400px] h-[400px] bg-blue-100 rounded-full opacity-40 -z-10"></div>
        <img
          src={brainImage}
          alt="AI Brain"
          className="w-full object-contain relative z-10"
        />
      </div>
    </div>
  </div>
</section>

     <section className="w-full px-4 md:px-8 lg:px-16 py-20 font-[Poppins]">
  <div className="max-w-screen-xl mx-auto">
    {/* Top Section */}
    <div className="flex flex-col lg:flex-row justify-between items-start gap-8">
      <div className="max-w-2xl">
        <div className="bg-[#E9F1FF] text-[#2F2F2F] text-sm font-medium px-4 py-1 rounded-full w-fit mb-4">
          OUR ADVANTAGES
        </div>
        <h2 className="text-[36px] leading-tight md:text-[44px] font-bold text-[#1A1A1A]">
          Trusted by operations<br className="hidden md:block" />
          teams across 10+<br className="hidden md:block" />
          countries
        </h2>
      </div>
      <p className="text-[#3F3F3F] top-[20px] text-base max-w-md">
        Our customers achieve faster fulfillment, reduced stockouts, and greater
        warehouse visibility — all within weeks.
      </p>
    </div>

    {/* Cards Section */}
    <div className="mt-14 flex flex-wrap gap-6">
      {/* Card 1 - 472x234 */}
      <div
        className="relative bg-[#F0F5FF] rounded-[24px] flex justify-between items-start p-6 w-full lg:w-[472px] h-[234px]"
      >
        <div className="w-[240px]">
          <h3 className="text-[#1A1A1A] text-[18px] font-semibold mb-2">
            85% Faster Order Processing
          </h3>
          <p className="text-[#717D96] text-[14px] leading-[22px]">
            Accelerate fulfillment speeds and reduce delays with intelligent, automated workflows.
          </p>
        </div>
        <img
          src={mapImage}
          alt="Map"
          className="w-[140px] h-auto object-contain"
        />
        <img
          src={iconMap}
          alt="Icon Map"
          className="absolute bottom-0 left-0 w-[70px] h-[70px]"
        />
      </div>

      {/* Wrap for Card 2 and 3 */}
      <div className="flex flex-col sm:flex-row gap-6 w-full lg:w-[744px]">
        {/* Card 2 - 352x234 */}
        <div className="relative bg-[#FCFCFC] rounded-[24px] p-6 border border-[#F2F2F2] w-full sm:w-[352px] h-[234px]">
          <h3 className="text-[#1A1A1A] text-[18px] font-semibold mb-2">
            99.9% Inventory Accuracy
          </h3>
          <p className="text-[#717D96] text-[14px] leading-[22px] max-w-[260px]">
            Maintain precise stock levels and eliminate costly inventory errors with real-time tracking.
          </p>
          <img
            src={iconMap}
            alt="Icon Map"
            className="absolute bottom-0 left-0 w-[70px] h-[70px]"
          />
        </div>

        {/* Card 3 - 352x234 */}
        <div className="relative bg-[#FCFCFC] rounded-[24px] p-6 border border-[#F2F2F2] w-full sm:w-[352px] h-[234px]">
          <h3 className="text-[#1A1A1A] text-[18px] font-semibold mb-2">
            40% Reduction in Stockouts
          </h3>
          <p className="text-[#717D96] text-[14px] leading-[22px] max-w-[260px]">
            Ensure product availability and boost customer satisfaction with smarter inventory planning.
          </p>
          <img
            src={iconMap}
            alt="Icon Map"
            className="absolute bottom-0 left-0 w-[70px] h-[70px]"
          />
        </div>
      </div>
    </div>
  </div>
</section>
    </>
  );
};

export default WarehouseHero;
